import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useSignal } from "@preact/signals";
import ComponentWithData from "../ComponentWithData";
import Image from "../Image";
import Loader from "../Loader";
import TabBar from "../TabBar";
import RequestManager from "../../lib/request-manager";
import style from "./style.module.scss";
export default function Filmstrip(props) {
    const { filmstripURL, videoURL, hideLabels, filterControls, videoOption = true } = props;
    const filmstripFilter = useSignal("image");
    const url = new URL(filmstripURL);
    const ival = url.searchParams.get("ival");
    const size = url.searchParams.get("thumbSize");
    const filmstripInterval = useSignal(ival ? ival : "500");
    const filmstripSize = useSignal(size ? size : "150");
    url.searchParams.set("ival", filmstripInterval.value);
    url.searchParams.set("thumbSize", filmstripSize.value);
    const getFilmstripData = RequestManager.makeExternalRequest(url.toString());
    return (_jsxs("div", { className: classNames(style["filmstrip"], "qa-filmstrip"), children: [videoOption === true && (_jsxs("div", { className: style["filmstrip__filters"], children: [filterControls, _jsx(TabBar, { options: [
                            {
                                label: "Image",
                                value: "image",
                            },
                            {
                                label: "Video",
                                value: "video",
                            },
                        ], selected: filmstripFilter.value, onChange: (selected) => {
                            filmstripFilter.value = selected;
                        } }), filmstripFilter.value === "image" && (_jsxs(_Fragment, { children: [_jsx(TabBar, { options: [
                                    {
                                        label: "0.1s",
                                        value: "100",
                                    },
                                    {
                                        label: "0.2s",
                                        value: "200",
                                    },
                                    {
                                        label: "0.5s",
                                        value: "500",
                                    },
                                    {
                                        label: "1s",
                                        value: "1000",
                                    },
                                    {
                                        label: "2s",
                                        value: "2000",
                                    },
                                    {
                                        label: "5s",
                                        value: "5000",
                                    },
                                ], selected: filmstripInterval.value, onChange: (selected) => {
                                    filmstripInterval.value = selected;
                                } }), _jsx(TabBar, { options: [
                                    {
                                        label: "Small",
                                        value: "100",
                                    },
                                    {
                                        label: "Medium",
                                        value: "150",
                                    },
                                    {
                                        label: "Large",
                                        value: "250",
                                    },
                                ], selected: filmstripSize.value, onChange: (selected) => {
                                    filmstripSize.value = selected;
                                } })] }))] })), filmstripFilter.value === "image" ? (_jsx(ComponentWithData, { data: getFilmstripData, loading: _jsx(Loader, { height: 117 }), component: (datafilmstrip) => {
                    // work out the highest number of frames
                    let frameTotal = 0;
                    datafilmstrip.filmstrips.forEach((filmstrip) => {
                        if (filmstrip.frames.length > frameTotal) {
                            frameTotal = filmstrip.frames.length;
                        }
                    });
                    // work out correct interval for labeling frames
                    const interval = datafilmstrip.interval;
                    return (_jsxs("div", { className: style["filmstrip__image"], children: [_jsx("div", { className: style["filmstrip__times"], children: [...Array(frameTotal)].map((_, index) => (_jsxs("div", { className: style["filmstrip__time"], style: { width: filmstripSize.value + "px" }, children: [(index * interval) / 1000, "s"] }, `${index * interval}`))) }), datafilmstrip.filmstrips
                                ? datafilmstrip.filmstrips.map((filmstrip) => {
                                    let filmstripName = filmstrip.name;
                                    if (!filmstrip.name || filmstrip.name.length === 0 || hideLabels) {
                                        filmstripName = "";
                                    }
                                    return (_jsxs("div", { className: classNames(style["filmstrip__strip"], "qa-filmstrip-strip"), children: [_jsx("div", { className: style["filmstrip__label"], style: { backgroundColor: filmstrip.color }, children: filmstripName }), filmstrip.frames.map((frame) => (_jsx("div", { children: _jsx("div", { className: style["filmstrip__thumb"], style: { width: filmstripSize.value + "px" }, children: _jsx("a", { href: window.accountUrl + "/test/" + filmstrip.id + "/", children: _jsx(Image, { src: frame.image, alt: frame.time }) }) }) }, frame.time)))] }, filmstrip.id));
                                })
                                : null] }));
                } })) : (_jsx(ComponentWithData, { data: getVideo(videoURL), loading: _jsx(Loader, { height: 117 }), component: (video) => {
                    return (_jsx("div", { className: style["filmstrip__video"], children: _jsx("video", { controls: true, autoPlay: true, width: video.data.width, height: video.data.height, children: _jsx("source", { src: forceHttps(video.data.videoUrl), type: "video/mp4" }) }) }));
                } }))] }));
}
// WPT's create.php response returns URLs with an http:// scheme, which the browser
// blocks as mixed content when the app is served over https. Force https to fix this.
function forceHttps(url) {
    return url ? url.replace(/^http:\/\//i, "https://") : url;
}
function getVideo(url) {
    return RequestManager.makeExternalRequest(url).then((response) => pollVideoUntilReady(forceHttps(response.data.jsonUrl)));
}
function pollVideoUntilReady(url) {
    return RequestManager.makeExternalRequest(url).then((response) => {
        if (response.statusCode !== 200) {
            // Video is still rendering so wait 2s and check status
            //console.log("video rendering");
            return new Promise((resolve) => {
                window.setTimeout(() => {
                    resolve(pollVideoUntilReady(url));
                }, 2000);
            });
        }
        // Video is ready, return the response
        return response;
    });
}
